import { TYPE } from '../actions/types'

export default function (state = {}, action) {
    switch (action.type) {
        case TYPE.AUTH:
            return { ...state, response: action.payload }
        case TYPE.CLEAR_SESSION:
            return { ...state, response: action.payload }
        default:
            return state;
    }
}

